import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home/index.vue";
import Dashboard from "./views/Dashboard/index.vue";
import Dataroom from "./views/Dataroom/index.vue";
import Login from "./views/login.vue";
import Password from "./views/password.vue";
import Profil from "./views/profil.vue";
import Detail from "./views/detail.vue";
import Evaluations from "./views/Evaluations/index.vue";
import EvaluationsAjout from "./views/Evaluations/ajout.vue";
import EvaluationsDetail from "./views/Evaluations/detail.vue";
import EvaluationsAnalyse from "./views/EvaluationsAnalyse/index.vue";
import EvaluationsAnalyseAjout from "./views/Evaluations/ajout.vue";
import EvaluationsAnalyseDetail from "./views/EvaluationsAnalyse/detail.vue";
import ExpertisesImmobilieres from "./views/ExpertisesImmobilieres/index.vue";
import ExpertisesImmobilieresAjout from "./views/ExpertisesImmobilieres/ajout.vue";
import DocumentsLegaux from "./views/DocumentsLegaux/index.vue";
import DocumentsLegauxAjout from "./views/DocumentsLegaux/ajout.vue";
import AvisValeurs from "./views/AvisValeurs/index.vue";
import AvisValeursAjout from "./views/AvisValeurs/ajout.vue";

Vue.use(Router);
const routes = [
  {
    path: "",
    component: Home,
    name: "Accueil",
    meta: {
      title: "[SITE_NAME] - Accueil",
      btn: "",
      listing: "Mes dernières demandes",
      sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",
    },
    children: [
      {path: "/", component: Home, name: "Accueil", meta: {title: "[SITE_NAME] - Accueil",btn: "",listing: "Mes dernières demandes",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",}},
    ]
  },
  {
    path: "/dataroom",
    component: Dataroom,
    name: "Dataroom",
    meta: {
      title: "[SITE_NAME] - Dataroom",
      btn: "",
      listing: "Mes derniers fichiers Dataroom",
      sublisting: "Retrouvez dans ce tableau l'ensemble de vos fichiers",
    },
    children: [
      {path: "/dataroom/", component: Dataroom, name: "Dataroom", meta: {title: "[SITE_NAME] - Dataroom",btn: "",listing: "Mes derniers fichiers Dataroom",sublisting: "Retrouvez dans ce tableau l'ensemble de vos fichiers",}},
    ]
  },
  {
    path: "/dashboard",
    component: Dashboard,
    name: "Dashboard",
    meta: {
      title: "[SITE_NAME] - Dashboard",
      btn: "",
      listing: "Mes dernières demandes",
      sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",
    },
    children: [
      {path: "/dashboard/", component: Dashboard, name: "Dashboard", meta: {title: "[SITE_NAME] - Dashboard",btn: "",listing: "Mes dernières demandes",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",}},
    ]
  },
  {
    path: "/login",
    component: Login,
    name: "Login",
    meta: {
      title: "[SITE_NAME] - Login"
    },
    children: [
      {path: ":token", component: Login, name: "Login", meta: {title: "[SITE_NAME] - Login"}},
      {path: ":token/:usid", component: Login, name: "Login", meta: {title: "[SITE_NAME] - Login"}}
    ]
  },
  {
    path: "/login/:type/:token/:username",
    component: Password,
    name: "Password",
    meta: {title: "[SITE_NAME] - Password"}
  },
  {
    path: "/profil",
    component: Profil,
    name: "Profil",
    meta: {
      title: "[SITE_NAME] - Mon profil"
    },
  },
  {
    path: "/logout",
    component: Login,
    name: "Logout",
    meta: {
      title: "[SITE_NAME] - Logout"
    },
  },
  {
    path: "/evaluations",
    component: Evaluations,
    name: "Evaluations",
    meta: {
      title: "[SITE_NAME] - [PRESTATION]",
      presta:'EVAL',
      btn: "[PRESTATION_BTN]",
      listing: "[PRESTATION_LISTING]",
      sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",
    },
    children: [
      {path: "/", component: Evaluations, name: "Vos évaluations", meta: {title: "[SITE_NAME] - [PRESTATION] - Liste", presta:'EVAL', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "ajout", component: EvaluationsAjout, name: "Evaluations", meta: {title: "[SITE_NAME] - [PRESTATION] - +", presta:'EVAL', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "detail/:id", component: EvaluationsDetail, name: "Evaluations - Détail", meta: {title: "[SITE_NAME] - [PRESTATION] - Détail", presta:'EVAL',btn: ""}}
    ]
  },
  {
    path: "/evaluations_analyse",
    component: EvaluationsAnalyse,
    name: "EvaluationsAnalyse",
    meta: {
      title: "[SITE_NAME] - [PRESTATION]",
      presta:'EXETR',
      btn: "[PRESTATION_BTN]",
      listing: "[PRESTATION_LISTING]",
      sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",
    },
    children: [
      {path: "/", component: EvaluationsAnalyse, name: "Vos évaluations", meta: {title: "[SITE_NAME] - [PRESTATION] - Liste", presta:'EXETR', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "ajout", component: EvaluationsAnalyseAjout, name: "EvaluationsAnalyse", meta: {title: "[SITE_NAME] - [PRESTATION] - +", presta:'EXETR', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "detail/:id", component: EvaluationsAnalyseDetail, name: "EvaluationsAnalyse - Détail", meta: {title: "[SITE_NAME] - [PRESTATION] - Détail", presta:'EXETR',btn: ""}},
      {path: "expert/:id/:token", component: EvaluationsAnalyseDetail, name: "EvaluationsAnalyse - Détail", meta: {title: "[SITE_NAME] - [PRESTATION] - Interface Expert", presta:'EXETR',btn: ""}}
    ]
  },
  {
    path: "/expertises_immobilieres",
    component: ExpertisesImmobilieres,
    name: "Expertises immobilières",
    meta: {
      title: "[SITE_NAME] - [PRESTATION]",
      presta:'EXIM',
      btn: "[PRESTATION_BTN]",
      listing: "[PRESTATION_LISTING]",
      sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",
    },
    children: [
      {path: "/", component: ExpertisesImmobilieres, name: "Expertises immobilières - Liste", meta: {title: "[SITE_NAME] - [PRESTATION] - Liste", presta:'EXIM', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "ajout", component: ExpertisesImmobilieresAjout, name: "Expertises immobilières", meta: {title: "[SITE_NAME] - [PRESTATION] - +", presta:'EXIM', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "detail/:id", component: Detail, name: "Expertises immobilières - Rapports et Factures", meta: {title: "[SITE_NAME] - [PRESTATION] - Rapports et Factures", presta:'EXIM', btn: ""}}
    ]
  },
  {
    path: "/documents_legaux",
    component: DocumentsLegaux,
    name: "Documents légaux",
    meta: {
      title: "[SITE_NAME] - [PRESTATION]",
      presta:'DOCL',
      btn: "[PRESTATION_BTN]",
      listing: "[PRESTATION_LISTING]",
      sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",
    },
    children: [
      {path: "/", component: DocumentsLegaux, name: "Documents légaux - Liste", meta: {title: "[SITE_NAME] - [PRESTATION] - Liste", presta:'DOCL', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "ajout", component: DocumentsLegauxAjout, name: "Documents légaux", meta: {title: "[SITE_NAME] - [PRESTATION]", presta:'DOCL', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "detail/:id", component: Detail, name: "Documents Légaux - Rapports et Factures", meta: {title: "[SITE_NAME] - [PRESTATION] - Rapports et Factures", presta:'DOCL', btn: ""}}
    ]
  },
  {
    path: "/avis_valeurs",
    component: AvisValeurs,
    name: "Avis de valeur",
    meta: {
      title: "[SITE_NAME] - [PRESTATION]",
      presta:'AVAL',
      btn: "[PRESTATION_BTN]",
      listing: "[PRESTATION_LISTING]",
      sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées",
    },
    children: [
      {path: "/", component: AvisValeurs, name: "Avis de valeur - Liste", meta: {title: "[SITE_NAME] - [PRESTATION] - Liste", presta:'AVAL', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "ajout/", component: AvisValeursAjout, name: "Avis de valeur", meta: {title: "[SITE_NAME] - [PRESTATION]", presta:'AVAL', btn: "[PRESTATION_BTN]",listing: "[PRESTATION_LISTING]",sublisting: "Retrouvez dans ce tableau l'ensemble de vos commandes finalisées"}},
      {path: "detail/:id", component: Detail, name: "Avis de valeur - Rapports et Factures", meta: {title: "[SITE_NAME] - [PRESTATION] - Rapports et Factures", presta:'AVAL', btn: ""}}
    ]
  }
];
const router=new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes
});
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = (to.path.indexOf("/login")<0 && to.path.indexOf("/logout")<0 && to.path.indexOf("/evaluations_analyse/expert")<0);
  if (authRequired && !localStorage.getItem('user')) {
    return next({ 
      path: '/login', 
      query: { returnUrl: to.path } 
    });
  }

  next();
});
router.beforeResolve((to, from, next) => {
  var $ = window.jQuery = require('jquery') ;
  const authRequired = (to.path.indexOf("/login")<0 && to.path.indexOf("/logout")<0);
  if(authRequired){
    document.getElementById("body").classList.add("logged");
  }else{
    document.getElementById("body").classList.remove("logged");
  }
  if(to.path=='/'){
    document.getElementById("body").classList.add("home");
  }else{
    document.getElementById("body").classList.remove("home");
  }
  
  function testBrowser(regexp) { return regexp.test(window.navigator.userAgent);}
  function getBrowser() {
    if(testBrowser(/edge/i))return "edge";
    if(testBrowser(/opr/i) && (!!window.opr || !!window.opera))return "opera";
    if(testBrowser(/chrome/i) && !!window.chrome)return "chrome";
    if(testBrowser(/trident/i))return "ie";
    if(testBrowser(/firefox/i))return "firefox";
    if(testBrowser(/safari/i))return "safari";
    return "other";
  }
  document.getElementById("body").classList.add(getBrowser());
  if(to.path!="/"){
    window.setTimeout(function(){$("#menu_home,#menu_home_link").removeClass("active");},50);
  }
  return next();
});

export default router;
